import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import styled from 'styled-components'
import { StaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import AnimatedHeading from 'components/animated-heading-otros'

class Sitelock extends React.Component {

    shouldComponentUpdate() {
        return false
    }
      
    render() {

        const Section = styled.section`
            position: relative;
            overflow: hidden;
            background-color: #111;
            padding: 20px 0 30px 0;
            .heading {
                width: 100%;
            }                    
        `

        const ServiceRow = styled(Row)`
            margin-top: 150px;
        `

        const ServiceHeading = styled.h3`
            font-size: 28px;
            font-weight: 500;
            font-family: Oswald;
            color: #fff;
            a {
                /* Estilos para el enlace */
                text-decoration: none;
                font-size: 28px;
                font-weight: 500;
                font-family: Oswald;
                color: #fff;
            
            &:hover {
                color: #0174c3 !important;
                /* Utiliza la variable color: var(--hover-color, #004080) !important; para el color de hover o proporciona un valor predeterminado */
            }
        }  
        `
        const ServiceHeading3 = styled.h3`
            font-size: 28px;
            font-weight: 500;
            font-family: Oswald;
            color: #fff;
            a {
                /* Estilos para el enlace */
                text-decoration: none;
                font-size: 28px;
                font-weight: 500;
                font-family: Oswald;
                color: #fff;
            
            &:hover {
                color: #f3000b !important;
                /* Utiliza la variable color: var(--hover-color, #004080) !important; para el color de hover o proporciona un valor predeterminado */
            }
        }  
        `

        const Heading2 = styled.h2`
            font-size: 38px;
            font-weight: 500;
            font-family: Oswald;
            color: #0392f6;
            margin: 70px 0 10px 0;
            @media (max-width: 767px) {
                margin: 50px 0 20px 0;
                font-size: 30px;
                line-height: 40px;           
            }
        `

        const ServiceSeparator = styled.div`
            height: 2px;
            width: 50px;
            background-color: #0392f6;
            margin-bottom: 5px;
        `        

        const ServiceNumber = styled.p`
            position: absolute;
            font-size: 60px;
            color: #0392f6;
            font-weight: 900;
            top: -80px;
            opacity: .2;
            margin-bottom: 20px;
            transition: .2s;
        `

        const ServiceElement = styled.div`
            margin-bottom: 90px;
            border-radius: 20px;
            transition: .2s;
            position: relative;
            &:hover ${ServiceNumber} {
                opacity: .4 !important;
                color: #0392f6;
            }
        `

        const ServiceText = styled.p`
            font-size: 17px;
            font-weight: 300;
            color: #c5c5c5;
            padding-right: 25px;
        `

        const Text = styled.p`
            font-size: 20px;
            font-weight: 300;
            color: #fff;            
        `        

        const Color1 = styled.span`            
            color: #0392f6;            
        `

        const Element = styled.div`
      margin-bottom: 20px;
      text-align: center;
      img {
        max-height: 500px;
        max-width: 500px;
        width: 100%;
        height: auto;
      }
      transition: 0.2s;
      &:hover {
        transform: translateY(-10px);
      }
      @media (max-width: 767px) {
        width: 100%;          /* Ocupar todo el ancho de la pantalla */                    
        padding: 0;
        margin: 40px 0;            
        img {
          max-width: 100%;     /* Permitir que la imagen se estire a lo ancho */
          width: 100vw;        /* Igual que el viewport */
          height: auto;
          display: block;       /* Asegura que no tenga espacio extra por inline */          
        }        
      }
    `        


        return(
            <Section>
                <Container>
                    <AnimatedHeading text="S/MIME" />
                    <Row>
                        <Col md={12}>
                            
                                <Heading2>
                                    Certificado de correo DigiCert S/MIME
                                </Heading2>
                            
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            
                                <Text>
                                    Cuando un usuario envía un correo electrónico utilizando los certificados DigiCert S/MIME, el mensaje se cifra utilizando algoritmos de cifrado robustos,
                                    como RSA o ECC. Además, se añade una firma digital al correo electrónico para verificar la identidad del remitente y garantizar la integridad del mensaje.
                                    El destinatario del correo electrónico puede descifrar el mensaje y verificar la firma digital utilizando la clave pública correspondiente, asegurando
                                    que la comunicación permanezca privada e inalterada.
                                </Text>
                                <Heading2>
                                    Autenticidad, integridad y confidencialidad
                                </Heading2>
                                <Text>
                                    Los certificados DigiCert S/MIME para empresas validan sus remitentes, direcciones de correo electrónico y organización, garantizando que cada correo
                                    electrónico esté firmado y cifrado para evitar el phishing y la manipulación.
                                </Text>
                            
                        </Col>
                        <Col md={6}>
                            
                                <Element>
                                    <GatsbyImage image={this.props.image} alt="Certimail Colombia S/MIME" sizes="(max-width: 767px) 300px, 500px" />
                                </Element>
                            
                        </Col>
                    </Row>
                    <ServiceRow>
                        <Col md={4}>
                            
                                <ServiceElement>
                                    <ServiceNumber>
                                        <Color1>Encriptado</Color1>
                                    </ServiceNumber>
                                    <ServiceHeading3>
                                        Correo electrónico seguro
                                    </ServiceHeading3>
                                    <ServiceSeparator />
                                    <ServiceText>
                                        Proteja a sus empleados, socios y clientes contra ataques de phishing y, al mismo tiempo, evite que los piratas informáticos lean sus correos electrónicos.
                                        El certificado DigiCert Clase 1 S/MIME aplicará su propia firma criptográfica a los correos electrónicos para que los destinatarios puedan verificar
                                        rápidamente que el correo electrónico proviene de usted (y no de un ciberdelincuente). Además, el cifrado de extremo a extremo protege el contenido de su
                                        correo electrónico en todo momento para proteger los datos personales, las contraseñas, los secretos comerciales y otra información confidencial enviada
                                        por correo electrónico. Clase 1 significa que solo necesita validar su dominio o dirección de correo electrónico. Esto significa que puede obtener su
                                        certificado S/MIME en minutos. Y no sólo ahorrará tiempo con el certificado S/MIME DigiCert Clase 1, sino que también ahorrará dinero, ya que es uno de
                                        los certificados S/MIME más asequibles del mercado. ¡Y está respaldado por la principal CA del mundo, DigiCert!
                                    </ServiceText>
                                </ServiceElement>
                            
                        </Col>
                        <Col md={4}>
                            
                                <ServiceElement>
                                    <ServiceNumber>
                                        <Color1>Seguridad</Color1>
                                    </ServiceNumber>
                                    <ServiceHeading>
                                        Autenticación de dos factores
                                    </ServiceHeading>
                                    <ServiceSeparator />
                                    <ServiceText>
                                        Otro beneficio adicional que ofrece este certificado es que le permite aumentar la
                                        protección de su red, aplicaciones y servidores con autenticación de dos factores basada en certificados. Esto significa que puede asegurarse de que solo los
                                        usuarios autorizados puedan acceder a sus servidores que contienen datos confidenciales, como información de clientes o documentos financieros. Esto se hace
                                        permitiendo que solo los usuarios con un certificado de cliente autorizado accedan a su servidor. Los nombres de usuario y las contraseñas se han vuelto
                                        cada vez más poco fiables y vulnerables. Elimine el riesgo de depender únicamente de contraseñas y opte por un mayor nivel de seguridad con certificados de
                                        autenticación de clientes. Piense en la autenticación de dos factores de la misma manera que cuando su banquero solicita una segunda forma de
                                        identificación (como un pasaporte), asegurando que un delincuente no haya interceptado su forma de identificación más común.
                                    </ServiceText>
                                </ServiceElement>
                            
                        </Col>
                        <Col md={4}>
                            
                                <ServiceElement>
                                    <ServiceNumber>
                                        Firma
                                    </ServiceNumber>
                                    <ServiceHeading>
                                        Firma de documentos
                                    </ServiceHeading>
                                    <ServiceSeparator />
                                    <ServiceText>
                                        Un beneficio adicional del certificado DigiCert S/MIME es que le permite firmar digitalmente documentos de la empresa. Esto significa que cualquier persona que
                                        reciba el documento tendrá pruebas de que el documento proviene de quien dice provenir y sabrá que no hubo ninguna manipulación del documento durante el
                                        tránsito. La función de firma de documentos del certificado DigiCert S/MIME funciona con todo el paquete Microsoft Office. Sin embargo, si su empresa desea
                                        firmar archivos PDF de Adobe, le recomendamos utilizar el certificado de firma de documentos DigiCert, que se encuentra en la lista de confianza aprobada por Adobe.
                                    </ServiceText>
                                </ServiceElement>
                            
                        </Col>
                    </ServiceRow>
                </Container>
            </Section>
        )
    }

}

const Iconos = (props) => (
    <StaticQuery
      query={graphql`
        {
          file(relativePath: { eq: "certificado-de-correo.webp" }) {
            childImageSharp {
              gatsbyImageData(
                layout: CONSTRAINED
                placeholder: DOMINANT_COLOR
                quality: 80
                formats: [AUTO, WEBP, AVIF]
                width: 500
              )
            }
          }
        }
      `}
      render={(data) => {
        const image = getImage(data.file.childImageSharp.gatsbyImageData);
        return <Sitelock image={image} {...props} />;
      }}
    />
  );
  
  export default Iconos;
